import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface NewPasswordPayload {
  newPassword: string;
  onError?: (message: string) => void;
}

@Component({
  selector: 'app-new-password-card',
  standalone: false,
  templateUrl: './new-password-card.component.html',
  styleUrls: ['./new-password-card.component.css'],
})
export class NewPasswordCardComponent {
  @Input()  email            = '';
  @Output() newPasswordSubmit = new EventEmitter<NewPasswordPayload>();
  @Output() backToLogin       = new EventEmitter<void>();

  newPassword     = '';
  confirmPassword = '';
  showNew         = false;
  showConfirm     = false;
  loading         = false;
  errorMessage    = '';

  get passwordsMatch(): boolean { return this.newPassword === this.confirmPassword; }
  get formValid(): boolean {
    return this.newPassword.length >= 8 && this.passwordsMatch;
  }

  onSubmit(): void {
    if (!this.formValid || this.loading) return;
    this.loading      = true;
    this.errorMessage = '';
    this.newPasswordSubmit.emit({
      newPassword: this.newPassword,
      onError: (msg) => { this.errorMessage = msg; this.loading = false; },
    });
  }

  onBack(): void { this.backToLogin.emit(); }
}